// src/app/styles-globaux.js — la feuille de style globale de l'appli, posée
// dans <head> à l'ouverture (useSession). Déplacée à l'identique depuis
// src/App.jsx (P-3.5, squelette).

// Google Fonts import via style tag
const fontsStyle = `@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=Raleway:wght@400;500;600;700;800&family=Fraunces:ital,opsz,wght@0,9..144,400;0,9..144,600;0,9..144,700;1,9..144,400;1,9..144,600&family=Libre+Franklin:wght@300;400;500;600;700&display=swap');
*{box-sizing:border-box}
/* Fond de page BLANC (correction Dimitri 2026-08-14) : les cartes se
   détachent par leur bordure fine et leur ombre, plus par contraste de fond. */
.fbz-app{max-width:100%;min-height:100vh;background:#ffffff;font-family:'Libre Franklin',sans-serif}
.fbz-layout{display:flex;flex-direction:column}
.fbz-content{padding:14px}
.fbz-accueil{display:flex;flex-direction:column;gap:0}
.fbz-sidebar{width:100%}
.fbz-detail{display:none}
.fbz-mobile-drawer{display:block}
.log-row-item{cursor:pointer;transition:background .15s}
.log-row-item:hover{background:#f0f6ff!important}
.log-row-item.selected{background:#e8f2fd!important;border-left:3px solid #3d5166!important}
@media(min-width:768px){
  .fbz-app{max-width:100%}
  /* UNE seule largeur : 1100 partout (décision Dimitri 2026-08-14) — fini le
     saut 1200/1100/860 au milieu d'un même geste. Le proprio garde ses 960
     (espace de lecture client, shell séparé). */
  .fbz-content{padding:20px 24px;max-width:1100px;margin:0 auto}
  .fbz-accueil{flex-direction:row;gap:20px;align-items:flex-start}
  .fbz-sidebar{width:340px;flex-shrink:0;position:sticky;top:20px;max-height:calc(100vh - 100px);overflow-y:auto}
  .fbz-detail{display:block;flex:1;min-width:0}
  .fbz-mobile-drawer{display:none}
  .fbz-summary{grid-template-columns:1fr 1fr 1fr!important}
  /* .fbz-tab-content / .fbz-tab-wide : sur-contraintes retirées (largeur
     unique) — les classes restent posées dans le JSX, elles ne bornent plus. */
}
@media(min-width:1100px){
  .fbz-sidebar{width:380px}
}
/* Cibles tactiles ≥44 px (consigne Dimitri 2026-08-14, née de la QA Suivi :
   onglets à 39 px, lignes À décider à 42 px). MOBILE/TACTILE SEULEMENT — le
   desktop validé à l'écran garde ses hauteurs. La classe se pose sur les
   boutons concernés (onglets de barre, lignes À décider, et toute future
   cible du même gabarit). .fbz-zone-tactile : l'autre outil — ÉTEND la zone
   de contact (pseudo-élément ±9 px) SANS changer la hauteur visuelle, pour
   les cibles dont la hauteur EST le dessin (plage « Cliquer pour assigner »
   de la frise, 26 px). PAS d'accents graves dans ce commentaire : il vit DANS
   un template string — deux accents graves l'ont déjà coupé en deux (overlay
   de compil sur l'écran de Dimitri, 2026-08-14). */
@media(max-width:767.98px), (pointer:coarse){
  .fbz-cible-tactile{min-height:44px}
  /* R-1/R-2 (WCAG 2.5.8, légal EAA 06/2025) : HITBOX 44 px transparente —
     le dessin ne bouge pas, la zone de contact s'étend autour. */
  /* S-1 : les zones sûres des encoches/barres système — no-op au navigateur
     de bureau (env() vaut 0), actif le jour du wrap natif. */
  body{padding-top:env(safe-area-inset-top);padding-bottom:env(safe-area-inset-bottom);
    padding-left:env(safe-area-inset-left);padding-right:env(safe-area-inset-right)}
  .fbz-hitbox44{position:relative;z-index:1}
  .fbz-hitbox44::after{content:"";position:absolute;left:50%;top:50%;
    transform:translate(-50%,-50%);width:max(100%,44px);height:max(100%,44px)}
  .fbz-zone-tactile{position:relative}
  .fbz-zone-tactile::before{content:"";position:absolute;left:0;right:0;top:-9px;bottom:-9px}
}
/* La HAUTEUR de la barre deux étages (verdict 2026-09-06) — lue par les
   bascules collantes (FicheChrome). Ordinateur : étage marque (~53 px) +
   étage menu (~55 px) ; téléphone : le menu vit dans la barre du bas, seul
   l'étage marque reste. */
:root{--fbz-barre-h:108px}
@media(max-width:640px){:root{--fbz-barre-h:53px}}
/* Un chiffre CLIQUABLE de la carte de titre : curseur + léger fond au survol
   (spec Dimitri 2026-08-14 : rgba(255,255,255,.08), arrondi 8, padding). Le
   padding est rendu par une marge négative équivalente pour que chiffres
   cliquables et inertes restent alignés sur le même filet. */
.fbz-chiffre-clic{cursor:pointer;border:none;background:none;font:inherit;color:inherit;
  text-align:left;border-radius:8px;padding:4px 8px;margin:-4px -8px;transition:background .15s}
.fbz-chiffre-clic:hover{background:rgba(255,255,255,.08)}
@media(max-width:479.98px){
  .fbz-grid-3, .fbz-grid-4 {
    grid-template-columns: 1fr 1fr !important;
  }
  .fbz-scroll-x {
    background: linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,.06)) right center / 24px 100% no-repeat;
  }
}

/* ── Responsive Lot 0 — utilitaires partagés (mobile-first, BP 480/768/1100) ──
   Mécanique CSS-first (décision Dimitri) : ces classes vivent ICI (source
   unique) et sont consommées par les onglets du fan-out. Voir le mini-guide
   docs/handoff/responsive-lot0-guide.md. */
.fbz-row, .fbz-grid-collapse{display:grid;grid-template-columns:1fr;gap:12px}
@media(min-width:768px){
  .fbz-row, .fbz-grid-collapse{grid-template-columns:1fr 1fr}
}
.fbz-master-detail{display:flex;flex-direction:column;gap:0}
.fbz-md-master{width:100%}
@media(min-width:768px){
  .fbz-master-detail{flex-direction:row;gap:20px;align-items:flex-start}
  .fbz-md-master{width:300px;flex-shrink:0}
  .fbz-md-detail{flex:1;min-width:0}
}
.fbz-table-wrap{width:100%;overflow-x:auto;-webkit-overflow-scrolling:touch}
@media(max-width:767.98px){
  .fbz-table-wrap{
    background:linear-gradient(to right, rgba(0,0,0,0), rgba(0,0,0,.06)) right center / 20px 100% no-repeat;
  }
  .fbz-modal-sheet{
    position:fixed!important;inset:0!important;
    width:100vw!important;max-width:100vw!important;
    height:100dvh!important;max-height:100dvh!important;
    border-radius:0!important;margin:0!important;
    overflow-y:auto!important;-webkit-overflow-scrolling:touch;
  }
}
.fbz-tap{min-height:44px;min-width:44px}

/* ── Direction Artistique — mouvement niveau 2 (DESIGN.md §4) ──
   Utilitaires partagés (source unique). Le :hover/:active n'est pas faisable en
   inline-style → ces classes le portent. Consommées par le chrome partagé et,
   au fan-out, par les écrans. Discret : transitions .12s–.2s, courbes naturelles. */
.fbz-card{transition:transform .2s ease,box-shadow .2s ease}
.fbz-card:hover{transform:translateY(-3px);box-shadow:0 8px 24px rgba(33,83,135,.10)}
.fbz-press{transition:transform .12s ease,filter .15s ease}
.fbz-press:hover{filter:brightness(.96)}
.fbz-press:active{transform:scale(.96)}
.fbz-rowhover{transition:background .15s ease}
.fbz-rowhover:hover{background:#f1f4f8}
`

export { fontsStyle }
